import { IMovePage, ITemplate } from '../services/ApiServiceV1';

export function isTemplateOrMovePage(template: unknown): template is ITemplate | IMovePage {
  return (
    template !== undefined &&
    (template as ITemplate).id !== undefined &&
    (template as ITemplate).translations !== undefined
  );
}
